import React from 'react';
import BeehiveTopNav from './BeehiveTopNav.js';
import { useTheme } from '../../lib/theme-context.js';
import { HiveBackground } from './HiveBackground.js';

interface BeehiveLayoutProps {
  children: React.ReactNode;
}

const BeehiveLayout: React.FC<BeehiveLayoutProps> = ({ children }) => {
  const { theme } = useTheme();

  return (
    <div className="h-full min-h-0 bg-gradient-to-br from-[rgb(var(--arc-blue))] to-[rgb(var(--arc-navy))] text-white relative flex flex-col">
      {theme === 'hive' && <HiveBackground />}
      
      <div className="relative z-10 flex flex-col flex-1 min-h-0">
        <div className="flex-1 flex min-h-0">
          <main className="flex-1 bg-gradient-to-br from-[rgba(var(--arc-blue),0.50)] to-[rgba(var(--arc-navy),0.50)]">
            {children}
          </main>
        </div>
        
        <BeehiveTopNav />
      </div>
    </div>
  );
};

export default BeehiveLayout;
